import React from 'react'

import useReortTableStyles from './styles'

function createData(name, calories, fat, carbs) {
  return { name, calories, fat, carbs }
}

const rows = [
  createData('Total Capacity', '', 211.48, 'kWp'),
  createData('Average per day generation', 'INV1', 211.48, 'kWp'),
  createData('Average minimum per day expected', '', 921.48, 'kWp'),
  createData('Actual Performance %', '', '48 %', ''),
  createData('Average Actual IR', '', '48', 'kWp/m2'),
  createData('Average Actual Yield', '', '48', 'kWp/kWp'),
  createData(
    'Capacity Utilization Factor if maximum irradiation available for all solar hours this value should be 18-20%',
    '',
    '48 %',
    ''
  ),
  createData('Total Generation', '', '21248', 'kWp'),
  createData('Total revenue( @USD & cents)', '', '1548', 'USD'),
]

const ReortTable = ({ monthlyReportList, state, DeemedlogData }) => {
  const classes = useReortTableStyles()

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  }

  const thStyle = {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'left',
    backgroundColor: 'white',
  }

  const tdStyle = {
    border: '1px solid #dddddd',
    padding: '8px',
    textAlign: 'left',
    backgroundColor: 'white',
    minWidth: '150px',
  }

  const Tariff = state?.data?.proposalType?.tariff
    ? state?.data?.proposalType?.tariff
    : Number(state?.data?.proposalType?.totalMonthlyAmount)

  return (
    <div className={classes.root}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Summary</th>
            <th style={thStyle}></th>
            <th style={thStyle}>MoU</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>Total Capacity</td>
            <td style={tdStyle}>{state?.data?.plantSize}</td>
            <td style={tdStyle}>kWp</td>
          </tr>
          <tr>
            <td style={tdStyle}>Average per day generation</td>
            <td style={tdStyle}>
              {monthlyReportList?.generationPerDay &&
                parseFloat(monthlyReportList?.generationPerDay).toFixed(1)}
            </td>
            <td style={tdStyle}>kWp</td>
          </tr>
          <tr>
            <td style={tdStyle}>Average minimum per day expected</td>
            <td style={tdStyle}>
              {monthlyReportList?.perDayexpected &&
                parseFloat(monthlyReportList?.perDayexpected).toFixed(1)}
            </td>
            <td style={tdStyle}>kWp</td>
          </tr>
          <tr>
            <td style={tdStyle}>Actual Performance %</td>
            <td style={tdStyle}>
              {monthlyReportList?.actualPerformance &&
                parseFloat(monthlyReportList?.actualPerformance).toFixed(
                  1
                )}{' '}
              %
            </td>
            <td style={tdStyle}></td>
          </tr>
          <tr>
            <td style={tdStyle}>Average Actual IR</td>
            <td style={tdStyle}>
              {monthlyReportList?.actualIR &&
                parseFloat(monthlyReportList?.actualIR).toFixed(1)}
            </td>
            <td style={tdStyle}>kWp/m2</td>
          </tr>
          <tr>
            <td style={tdStyle}>Average Actual Yield</td>
            <td style={tdStyle}>
              {monthlyReportList?.actualYield &&
                parseFloat(monthlyReportList?.actualYield).toFixed(1)}
            </td>
            <td style={tdStyle}>kWp/m2</td>
          </tr>
          <tr>
            <td style={tdStyle}>
              Capacity Utilization Factor if maximum irradiation available for
              all solar hours this value should be 18-20%
            </td>
            <td style={tdStyle}>
              {parseFloat(monthlyReportList?.utilizationFactor).toFixed(1)}%
            </td>
            <td style={tdStyle}></td>
          </tr>

          <tr>
            <td style={tdStyle}>Total Generation</td>
            <td style={tdStyle}>
              {parseFloat(monthlyReportList?.totalGeneration).toFixed(1)}
            </td>
            <td style={tdStyle}>kWp</td>
          </tr>
          <tr>
            <td style={tdStyle}>Total revenue ({state?.data?.currency})</td>
            <td style={tdStyle}>
              {parseFloat(monthlyReportList?.totalGeneration * Tariff).toFixed(
                1
              )}
            </td>
            <td style={tdStyle}>{state?.data?.currency}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

ReortTable.propTypes = {}

export default ReortTable
